import React, { FC, memo, useEffect, useRef } from "react";
import { AmsaInputProps } from "../../interfaces/AmsaInputs";

const GTPAL: FC<AmsaInputProps> = ({
  data,
  setValue,
  shouldFocus,
}: AmsaInputProps) => {
  const gRef = useRef<HTMLInputElement>(null);
  const tRef = useRef<HTMLInputElement>(null);
  const pRef = useRef<HTMLInputElement>(null);
  const aRef = useRef<HTMLInputElement>(null);
  const lRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (gRef.current && shouldFocus) {
      gRef.current.focus();
    }
  }, [shouldFocus]);

  // Initialize values if not present
  // Handle both object and string (JSON) formats
  let values: { G: string; T: string; P: string; A: string; L: string };
  if (!data.value) {
    values = { G: "", T: "", P: "", A: "", L: "" };
  } else if (typeof data.value === "string") {
    try {
      values = JSON.parse(data.value);
    } catch {
      values = { G: "", T: "", P: "", A: "", L: "" };
    }
  } else {
    values = data.value;
  }

  const handleInputChange = (field: string, value: string) => {
    const updatedValues = {
      ...values,
      [field]: value,
    };

    // Create a synthetic event-like object for setValue
    const syntheticEvent = {
      target: {
        value: JSON.stringify(updatedValues),
      },
    };

    setValue(syntheticEvent);
  };

  return (
    <div className="block">
      <label className="block mb-2 text-sm font-medium leading-6 text-gray-900">
        {data.label || "GTPAL"}
      </label>
      <div className="flex items-center gap-1.5">
        <div className="flex flex-col items-center">
          <input
            ref={gRef}
            type="number"
            placeholder="G"
            value={values.G || ""}
            onChange={(e) => handleInputChange("G", e.target.value)}
            className="w-10 h-10 text-center rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            maxLength={1}
          />
        </div>
        <div className="flex flex-col items-center">
          <input
            ref={tRef}
            type="number"
            placeholder="T"
            value={values.T || ""}
            onChange={(e) => handleInputChange("T", e.target.value)}
            className="w-10 h-10 text-center rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            maxLength={1}
          />
        </div>
        <div className="flex flex-col items-center">
          <input
            ref={pRef}
            type="number"
            placeholder="P"
            value={values.P || ""}
            onChange={(e) => handleInputChange("P", e.target.value)}
            className="w-10 h-10 text-center rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            maxLength={1}
          />
        </div>
        <div className="flex flex-col items-center">
          <input
            ref={aRef}
            type="number"
            placeholder="A"
            value={values.A || ""}
            onChange={(e) => handleInputChange("A", e.target.value)}
            className="w-10 h-10 text-center rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            maxLength={1}
          />
        </div>
        <div className="flex flex-col items-center">
          <input
            ref={lRef}
            type="number"
            placeholder="L"
            value={values.L || ""}
            onChange={(e) => handleInputChange("L", e.target.value)}
            className="w-10 h-10 text-center rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            maxLength={1}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(GTPAL);
